import React from 'react';
import KeyboardButton from './KeyboardButton';

export default class Keyboard extends React.Component {
  render() {
    return (
      <div id="keyboard">
        <div id="numkeys">
          <KeyboardButton text="1" />
          <KeyboardButton text="2" />
          <KeyboardButton text="3" />
          <KeyboardButton text="4" />
          <KeyboardButton text="5" />
          <KeyboardButton text="6" />
          <KeyboardButton text="7" />
          <KeyboardButton text="8" />
          <KeyboardButton text="9" />
          <KeyboardButton text="." />
          <KeyboardButton text="0" />
          <KeyboardButton text="x" />
        </div>
        <div id="functionkeys">
          <KeyboardButton text="back" icon="large caret left icon" />
          <KeyboardButton text="€" />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/components/Keyboard.jsx